<template>
  <div class="field-group">
    <label @click="focus">{{ label }}</label>
    <slot v-if="isAllowed"/>
    <div v-else class="readonly">
      <span v-if="value">{{ value }}</span>
      <span v-else>-</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    isAllowed: {
      type: Boolean,
      required: true
    },
    value: {
      type: String | null,
      required: true
    }
  },
  methods: {
    focus() {
      if (this.$slots.default[0] && this.$slots.default[0].elm) {
        this.$slots.default[0].elm.focus();
      }
    }
  }
};
</script>
